import axios from 'axios';
import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useLineStore = defineStore('line', () => {
    // Refs initialize
    const initialState = {
        liffApps: {
            //測試環境
            debug: {
                hc_member_link: '2005564827-xoHmD57p',
                hc_account_link: '2005564827-wwIASXPL',
            },
            //正式環境
            production: {
                hc_member_link: '2005564827-asbCcO02',
                hc_account_link: '2005564827-BgkvRzX8',
            },
        },
        auth: false,
        token: null,
        isLinked: false,
        isExternal: false,
        profile: {},
        prev: null,
    };

    // Refs mapping
    const state = Object.entries(initialState).reduce((acc, [key, value]) => {
        acc[key] = ref(value);
        return acc;
    }, {});

    // Set multiple props
    function setProps(updates) {
        Object.entries(updates).forEach(([key, value]) => {
            if (key in state) {
                state[key].value = value;
            } else {
                console.warn(`未定義的 key: ${key}`);
            }
        });
    }

    // Reset all states
    function reset() {
        Object.entries(initialState).forEach(([key, value]) => {
            state[key].value = value;
        });
    }

    const tokenVerify = async ({ token } = {}) => {

        if (!token) {
            throw new Error('Token is required');
        }

        const url = route('hc.api.line.token-verify');
        const params = { token };
        const response = await axios.post(url, params);

        if (response?.data?.sub) {
            state['token'].value = token;
            state['profile'].value = response.data;
            return response.data;
        }
        return;
    };

    // 利用 line user id 去綁定會員
    const linkAccountByLineId = async () => {
        if (!state?.profile?.value?.sub) {
            return;
        }
        const url = route('hc.api.member.v3.line-link-account');
        const params = {
            id: state?.profile?.value?.sub,
            token: state?.token?.value,
        };
        const response = await axios.post(url, params);
        console.log('response', response);
        console.log('profile', state?.profile?.value?.sub);
    };

    return {
        // 擴充所有狀態
        ...state,
        // 設定多個屬性, 重置所有狀態
        setProps, reset,
        tokenVerify, linkAccountByLineId
    };
});
